import { DateTime } from '@ksyos/date-time';

export function calculateAge(birthDate: string | Date, referenceDate?: Date | string) {
    return DateTime.from(referenceDate ? referenceDate : new Date()).diff(birthDate, 'years');
}
